module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot6-da4fdf76bb4230b7451a45b32e879e14.png";